export default __webpack_public_path__ + "static/media/left-emergencia.71744d98.png";